import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { SharedService } from "./../shared/shared.service";
import { PujaPrasadMaster } from "./puja-prasad-master";

@Injectable()
export class PujaPrasadService {

  constructor(private _http: HttpClient) { }

  ServiceUrl: string = SharedService.BaseServiceUrl + "puja/vidhis";


  getPujaDetails(): Observable<PujaPrasadMaster[]> {
    return this._http.get<PujaPrasadMaster[]>(this.ServiceUrl);
  }

  getPujaDetailById(id: number): Observable<PujaPrasadMaster> {
    let customUrl = this.ServiceUrl + "/" + id.toString();
    return this._http.get<PujaPrasadMaster>(customUrl);
  }

}



// WEBPACK FOOTER //
// ./src/app/prasad-order/puja-prasad.service.ts